__turbopack_context__.v({
  "header_container": "styles-module-scss-module__xk3g7W__header_container",
  "loading_container": "styles-module-scss-module__xk3g7W__loading_container",
  "see_all_link": "styles-module-scss-module__xk3g7W__see_all_link",
});
